import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import PhoneInput from 'react-phone-number-input';
// import Parser from 'html-react-parser';
import useToggle from '../../../Hooks/useToggle';
import BackToTop from '../../BackToTop';
// import Footer from '../../../Helper/Footer';
import Drawer from '../../Mobile/DrawerInstitute';

import Header from '../../Helper/HeaderInstitute';
import Footer from '../../Helper/FooterInstitute';

import { BASEAPIURL, UPLOADNODEURLCDN } from '../../../config';
import './bookaclass.css';

const serialize = require('form-serialize');

function BookTeamLearn() {
    const { t } = useTranslation();
    const [drawer, drawerAction] = useToggle(false);
    const [msgcolor, setMsgcolor] = useState('red');
    const [courseName, setCourseName] = useState(localStorage.getItem('TeamReqCourse'));
    localStorage.removeItem('TeamReqCourse');
    const [showSent, setshowSent] = useState(false);

    const [forCourses, setForCourses] = useState([]);

    const FilterCoursesbyKeyword = async (keyword) => {
        try {
            const res = await fetch(`${BASEAPIURL}/course/getAll`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    SortStatus: 1,
                    recordsPerPage: 10,
                    keyword: keyword ? keyword.trim() : '',
                    sortby: 'a2z',
                }),
            });
            const resJson = await res.json();
            if (res.status === 200) {
                if (resJson.data.length > 0) {
                    setForCourses(resJson.data);
                } else{
                    setForCourses([]);
                }
            }
        } catch (err) {
            setForCourses([]);
            console.log(err.message);
        }
        return 1;
    };

    const [message, setMessage] = useState('');
    const [Participants, setParticipants] = useState('');
    const [Notes, setNotes] = useState('');
    const [PhoneNumber, setPhoneNumber] = useState('');

    const form = document.querySelector('#Inst-Enq-Form-team');
    const obj = serialize(form, { hash: true, empty: true });

    function closeshowSent() {
        setshowSent(false);
    }

    async function handleSubmit() {
        try {
            setMsgcolor('green');
            const url = `${BASEAPIURL}/institute/enquiry/requestasteam`;
            const formData = new FormData();
            Object.keys(obj).map((index) => {
                formData.append(index, obj[index]);
                return index;
            });
            const config = {
                headers: {
                    'content-type': 'application/json', // multipart/form-data
                },
            };
            axios.post(url, formData, config).then((response) => {
                console.log(response);
                setMessage(response.data.message);
                if (response.data.status === 1) {
                    setMessage('');
                    setshowSent(true);
                    document.getElementById('Inst-Enq-Form-team').reset();
                    setMessage('');
                    setParticipants('');
                    setNotes('');
                    setPhoneNumber('');
                    setCourseName('');
                }
            });
        } catch (err) {
            setMsgcolor('red');
            console.log(err);
            setMessage('Something went wrong, Please try again later.');
        }
    }

    function getdefaultCountry() {
        let send = 'IN';
        const country_name = localStorage.getItem('country_name');
        if (country_name === 'India') {
            send = 'IN';
        }
        if (country_name === 'United Arab Emirates') {
            send = 'AE';
        }
        return send;
    }

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <Header drawer={drawer} action={drawerAction.toggle} />
            <>
                {showSent && (
                    <div>
                        <div className="mfp-bg mfp-ready"></div>
                        <div
                            className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready"
                            tabIndex="-1"
                            style={{ overflow: ' hidden auto' }}
                        >
                            <div className="mfp-container mfp-s-ready mfp-iframe-holder">
                                <div className="mfp-content" style={{ maxWidth: 'max-content' }}>
                                    <div className="mfp-iframe-scaler-old">
                                        <button
                                            onClick={closeshowSent}
                                            title="Close (Esc)"
                                            type="button"
                                            className="mfp-close"
                                        >
                                            ×
                                        </button>
                                    </div>
                                    <div
                                        className="mfp-iframe p-4 text-center"
                                        style={{ background: '#fff' }}
                                    >
                                        <i
                                            // src={`${IMGBASEAPIURL}institute/bookaclass.svg`}
                                            // alt="Enquiry Sent"
                                            className="mb-3 fa fa-check fa-2x"
                                        />
                                        <h3 className="pagetitle mb-3">Enquiry Sent</h3>
                                        <h4 className="mt-3 mb-3">
                                            We will get back to you soon.
                                        </h4>
                                    </div>
                                </div>
                                <div className="mfp-preloader">Loading...</div>
                            </div>
                        </div>
                    </div>
                )}
                <section
                    className="pt-80 pb-80"
                    style={{
                        backgroundImage: `url(assets/img/team-bg.jpg)`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ry_instr_shadow">
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="m-4 p-4">
                                                 {t('langCode') === 'en' && (
                                                    <>
                                                        <h3 className="">Learn Together, Grow Together</h3>
                                                        <h5 className="mt-4">Unlock the power of collective learning with Acumen Glow!</h5>
                                                        <p className="mt-4">Our team learning programs are designed to enhance skills and build synergy within groups. Whether you're a corporate team, a study group, or a community organization, we offer exclusive discounted rates for group enrollments. </p>
                                                        <p className="mt-4">Empower your team with the skills to succeed in today's fast-paced world.</p>
                                                        <h6 className="mt-4">Get started today and transform learning into a shared success story!</h6>
                                                    </>
                                                 )}
                                                 
                                                 {t('langCode') === 'fr' && (
                                                    <>
                                                        <h3 className="">Apprendre ensemble, progresser ensemble</h3>
                                                        <h5 className="mt-4">Libérez le potentiel de l'apprentissage collectif avec Acumen Glow !</h5>
                                                        <p className="mt-4">Nos programmes d’apprentissage en équipe sont conçus pour renforcer les compétences et créer une synergie entre les membres d’un groupe. Que vous soyez une équipe d’entreprise, un groupe d’étude ou une organisation communautaire, nous proposons des tarifs réduits pour les inscriptions groupées. </p>
                                                        <p className="mt-4">Donnez à votre équipe les moyens de réussir dans un monde en perpétuel mouvement.</p>
                                                        <h6 className="mt-4">Commencez dès aujourd’hui et faites de l’apprentissage une réussite partagée !</h6>
                                                    </>
                                                 )}

                                                 {t('langCode') === 'pt' && (
                                                    <>
                                                        <h3 className="">Aprendam Juntos, Cresçam Juntos</h3>
                                                        <h5 className="mt-4">Desbloqueie o poder da aprendizagem coletiva com a Acumen Glow!</h5>
                                                        <p className="mt-4">Os nossos programas de aprendizagem em equipa são concebidos para desenvolver competências e promover a sinergia entre grupos. Seja uma equipa corporativa, um grupo de estudo ou uma organização comunitária, oferecemos tarifas exclusivas com desconto para inscrições em grupo.</p>
                                                        <p className="mt-4">Capacite a sua equipa com as competências necessárias para ter sucesso no mundo acelerado de hoje.</p>
                                                        <h6 className="mt-4">Comece hoje mesmo e transforme a aprendizagem numa história de sucesso partilhada!</h6>
                                                    </>
                                                 )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <form
                                                id="Inst-Enq-Form-team"
                                                className="bookaclass_frm p-4"
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                }}
                                            >
                                                {/* <img src="assets/img/bac_top.png" alt="Acumen Glow" /> */}

                                                <h5 className="text-center text-white mt-3 mb-3">
                                                    Please fill out the form
                                                </h5>

                                                <div className="row mr-3 ml-3">
                                                    <div className="col-md-6 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <label>First Name*</label>
                                                            <input
                                                                type="text"
                                                                name="fname"
                                                                placeholder="First name"
                                                                className="form-control"
                                                                required="required"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <label>Last Name*</label>
                                                            <input
                                                                type="text"
                                                                name="lname"
                                                                placeholder="Last name"
                                                                className="form-control"
                                                                required="required"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mr-3 ml-3 mt-1">
                                                    <div className="col-md-6 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <label>Email*</label>
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                placeholder="Email"
                                                                className="form-control"
                                                                required="required"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 pr-1 pl-1">
                                                        <div className="form-group mb-2">
                                                            <label>Phone Number*</label>
                                                            <PhoneInput
                                                                international
                                                                className="form-control"
                                                                name="phonenumber"
                                                                value={PhoneNumber}
                                                                onChange={setPhoneNumber}
                                                                required
                                                                defaultCountry={getdefaultCountry()}
                                                                style={{ position: 'relative' }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mr-3 ml-3 mt-1">
                                                    <div className="col-md-6 pr-1 pl-1">
                                                        <div className="form-group mb-2">
                                                            <label>Course</label>
                                                            <input
                                                                type="text"
                                                                name="course"
                                                                className="form-control"
                                                                placeholder="Select Course"
                                                                value={courseName}
                                                                onClick={(e) => {
                                                                    FilterCoursesbyKeyword(courseName);
                                                                }}
                                                                onChange={(e) => {
                                                                    FilterCoursesbyKeyword(e.target.value);
                                                                    setCourseName(e.target.value);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <label>No. of participants*</label>
                                                            <input
                                                                type="number"
                                                                min={0}
                                                                name="participants"
                                                                placeholder="No. of participants"
                                                                className="form-control"
                                                                required="required"
                                                                onChange={(e) =>
                                                                    setParticipants(e.target.value)
                                                                }
                                                                value={Participants}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-md-12'>
                                                        <div className='SearchAnythingResult d-block' style={{ top: '0px' }}>
                                                            {forCourses.map((singi) => (
                                                                <div key={singi.courseid} className="KeySearchDivContent">
                                                                    <div
                                                                        to={`/course/${singi.courseslug}`}
                                                                        onClick={() => {
                                                                            setCourseName(singi.title);
                                                                            setForCourses([]);
                                                                        }}
                                                                    >
                                                                        <img
                                                                            src={`${UPLOADNODEURLCDN}${singi.image}`}
                                                                            alt={singi.title}
                                                                            style={{
                                                                                maxWidth: '90px',
                                                                                marginRight: '10px',
                                                                                float: 'left',
                                                                            }}
                                                                        />
                                                                        <div>
                                                                            <b style={{ display: 'block' }}>{singi.title}</b>
                                                                            <p><small>{singi.meta_description}</small></p>
                                                                        </div>
                                                                        <div style={{ clear: 'both' }}></div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mr-3 ml-3">
                                                    <div className="col-md-12 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <label>Additional notes</label>
                                                            <textarea
                                                                type="date"
                                                                name="notes"
                                                                placeholder="Additional notes"
                                                                className="form-control"
                                                                onChange={(e) =>
                                                                    setNotes(e.target.value)
                                                                }
                                                                value={Notes}
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="row mr-3 ml-3">
                                                    <div className="col-md-12 pr-1 pl-1">
                                                        <div className="form-group  mb-2">
                                                            <div
                                                                className="message mb-3"
                                                                style={{ color: msgcolor }}
                                                            >
                                                                {message ? <span>{message}</span> : ''}
                                                            </div>
                                                            <button
                                                                type="submit"
                                                                className="btn btn-docsta-instructor"
                                                            >
                                                                Send Enquiry
                                                            </button>
                                                            <small>
                                                                Field with * are required to complete the request.
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <img src="assets/img/bac_foot.png" alt="Acumen Glow" className="mt-4" /> */}
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-1"></div>
                        </div>
                    </div>
                </section>
            </>
            <Footer className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default BookTeamLearn;
